// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__2rgRL","footer":"ModalFilter_footer__1HTgS"};